module.exports = __webpack_public_path__ + "img/microplastics-6.5b098426.png";